import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=35fe8e06&"
import script from "./bills.vue?vue&type=script&lang=ts&"
export * from "./bills.vue?vue&type=script&lang=ts&"
import style0 from "./bills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bills.vue"
export default component.exports